import { css } from 'styled-components';

/**
 * Styling shared between the Creative view's two toolbars, which live in
 * separate subtrees - AdList/AdListToolbar and AdView/AdViewToolbar.
 *
 * This file sits at their nearest common ancestor rather than in components/UI,
 * and that is deliberate. It is not a reusable widget; it is one view's two
 * toolbars agreeing on a state treatment.
 */

/**
 * The "the drawer this button opens is currently open" treatment, applied by
 * FiltersButton and DrawerToolbarButton.
 *
 * Wrapped in `&&` rather than written flat, because both callers are
 * `styled(BaseButton)` around antd's Button. An `&.selected` block compiled to
 * `.sc-hash.selected` - specificity (0,2,0), comfortably above antd's own
 * `.ant-btn` rules at (0,1,0). Flat declarations would sit at (0,1,0) too,
 * tying with antd and leaving the winner to stylesheet injection order, which
 * styled-components and antd's cssinjs do not coordinate. `&&` compiles to
 * `.sc-hash.sc-hash` and restores (0,2,0).
 *
 * A plain `styled.div` has no competing stylesheet and would not need this.
 */
export const selectedToolbarButtonStyles = css`
  && {
    background: #a8a8a8;
    border-color: #989696;
    color: white;
  }
`;
